import { useEffect } from "react";
import { PremiumPaywallSignModes, AuthStepsEnum, SubscriptionPlan } from "../../../../global/paywall/paywallInterfaces";
import { LegalLink, PremiumPaywallState } from "./premiumPaywallMobile";
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { PremiumPaywallMobileSignupPassword } from "./signup/premiumPaywallMobileSignupPassword";
import { PremiumPayWallMobileSignupConfirmTerms } from "./signup/premiumPaywallMobileSignupConfirmTerms";
import PremiumPaywallCheckoutPlans from "../desktop/premiumPaywallPlans";
import { PremiumPaywalllMobileSignupEmail } from "./signup/premiumPaywallMobileSignupEmail";

 
interface PremiumPaywallMobileSignUpProps {
  email: string
  password: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void;
  setSelectedPlan?: (plan: SubscriptionPlan | null) => void;  
}

export const PremiumPaywallMobileSignUp = (props: PremiumPaywallMobileSignUpProps) => {

  const { email, setEmail, password, setPassword, setMode, agreesTerms, setAgreesTerms,setIsRedirecting} = props

  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailForLogin,
    submitPassword,
    resetAuth,
    handleChoosePlan,
  } = getAuthHookFactory("signup",AuthStepsEnum.PLANS)();

  const sendMail = () => {
    sendEmailForLogin(email, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onReset = () => {
    resetAuth()
    setAgreesTerms(false)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => { 
    thirdPartyLogin(isNewCustomer)
  }

  switch (step) {
    case AuthStepsEnum.PLANS:
      return (
        <PremiumPaywallCheckoutPlans
        handleChoosePlan={handleChoosePlan}
           setMode={setMode}
        />)
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumPaywalllMobileSignupEmail
        email={email}
        agreesTerms={agreesTerms}
        setEmail={setEmail}
        setAgreesTerms={setAgreesTerms}
        setMode={setMode}
        loginWithGoogle={loginWithGoogle}
        loginWithApple={loginWithApple}
        sendMail={sendMail}
        authError={authError}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallMobileSignupPassword
          email={email}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          onBack={onReset}
          sendMail={sendMail}
          authError={authError}
        />
      )

      // case AuthStepsEnum.CONFIRM_TERMS:
      //   return (
      //     <PremiumPayWallMobileSignupConfirmTerms 
      //       resetAuth={onReset}
      //       thirdPartyLogin={onThirdPartyLogin}
      //     />
      //   )

      case AuthStepsEnum.FINISH:
        setIsRedirecting (true)
        return null;

    default:
      return null
  }
};
